import { AGENT_MODEL, TestMode, TestModeLabel, TestTypeValue } from '@nrwl/common-lib';

export const TEST_AGENT_INFO = {
  [TestTypeValue.TRUESPEED]: [
    {
      testMode: TestMode.CLIENT_TO_MA,
      agentTypes: ['vta-ts', 'map-2100', 'qt600-10', 'vspa-sat-ts'],
      agentCapabilityCheck: {
        section: 'truespeed',
        field: 'public-access',
        value: 'true',
        section1: 'truespeed-list'
      },
      showDestination: false,
      testModeName: TestModeLabel.CLIENT_TO_MA
    },

    {
      testMode: TestMode.MA_TO_MA,
      agentTypes: [
        'vta',
        'qt600-10',
        'map-2100',
        'nsc',
        'sat-probe',
        'vqt',
        'jmep-10g',
        'vspa-sat'
      ],
      showDestination: true,
      destinationFilter: [
        {
          sourceAgent: ['qt600-10', 'map-2100', 'nsc', 'sat-probe', 'vqt'],
          destinationAgent: [
            'vta',
            'qt600-10',
            'map-2100',
            'nsc',
            'sat-probe',
            'vqt',
            'vspa-sat',
            'vspa-sat-ts'
          ]
        },
        {
          sourceAgent: ['vta', 'vspa-sat'],
          destinationAgent: [
            'vta',
            'qt600-10',
            'map-2100',
            'nsc',
            'sat-probe',
            'vqt',
            'jmep-10g',
            'vspa-sat'
          ]
        },
        {
          sourceAgent: ['jmep-10g'],
          destinationAgent: ['vta', 'jmep-10g', 'vta-ts', 'vspa-sat', 'vspa-sat-ts']
        },
        {
          sourceAgent: ['vta-ts', 'vspa-sat-ts'],
          destinationAgent: ['vta', 'jmep-10g', 'vta-ts', 'vspa-sat', 'vspa-sat-ts']
        }
      ],
      testModeName: TestModeLabel.MA_TO_MA,
      agentCapabilityCheck: {
        section: 'truespeed',
        section1: 'truespeed-list'
      }
    },
    {
      testMode: TestMode.MA_TO_JMEP,
      agentTypes: ['vta', 'vspa-sat'],
      agentCapabilityCheck: {
        section: 'truespeed',
        field: 'jmep-support',
        value: 'true',
        section1: 'truespeed-list'
      },
      destAgentTypes: ['jmep-1g', 'jmep-10g'],
      destAgentCapabilityCheck: {
        section: 'simpleTestConfig',
        field: 'rfc6349-responder',
        value: 'true',
        section1: 'truespeed-list'
      },
      showDestination: true,
      testModeName: TestModeLabel.MA_TO_JMEP
    }
  ],
  [TestTypeValue.VOIP]: [
    {
      testMode: TestMode.DEFAULT,
      agentTypes: ['vqt', 'vspa-pm-l'],
      showDestination: true
    }
  ],
  [TestTypeValue.Y1564]: [
    {
      testMode: TestMode.LOOPBACK,
      agentTypes: [
        'vta',
        'qt600-10',
        'map-2100',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'jmep',
        'jmep-1g',
        'jmep-10g',
        'vspa-sat'
      ],
      showDestination: true,
      destAgentTypes: [
        'unmanaged',
        'vta-lb',
        'vspa-sat-lb',
        AGENT_MODEL.JMEP_10G,
        AGENT_MODEL.JMEP_1G
      ],
      testModeName: TestModeLabel.LOOPBACK
    },
    {
      testMode: TestMode.UNIDIRECIONAL,
      agentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      showDestination: true,
      destAgentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      testModeName: TestModeLabel.MA_TO_MA
    },
    {
      testMode: TestMode.SEQUENTIAL,
      agentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      showDestination: true,
      destAgentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      testModeName: TestModeLabel.SEQUENTIAL
    },
    {
      testMode: TestMode.CONCURRENT,
      agentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      showDestination: true,
      destAgentTypes: [
        'vta',
        'tb/mts-5800-100g',
        'tb/mts-5800v2',
        'mts-5882',
        'sc4800',
        'sc4800p',
        'tb-5800v2',
        'mts-5800v2',
        'tb-5882',
        'tb-5800-100g',
        'mts-5800-100g',
        'vspa-sat'
      ],
      testModeName: TestModeLabel.CONCURRENT
    }
  ],
  [TestTypeValue.RFC2544]: [
    {
      testMode: TestMode.LOOPBACK,
      agentTypes: ['qt600-10', 'map-2100'],
      showDestination: true,
      destAgentTypes: [
        'unmanaged',
        'vta-lb',
        'vspa-sat-lb',
        AGENT_MODEL.JMEP_10G,
        AGENT_MODEL.JMEP_1G
      ],
      testModeName: TestModeLabel.LOOPBACK
    }
  ],
  [TestTypeValue.SERVICE_CONTINUITY]: [
    {
      testMode: TestMode.DEFAULT,
      agentTypes: ['vqt', 'vspa-pm-l'],
      showDestination: false
    }
  ],
  [TestTypeValue.MULTISTEP]: [
    {
      testMode: TestMode.DEFAULT,
      agentTypes: ['vqt', 'vspa-pm-l'],
      showDestination: false
    }
  ],
  [TestTypeValue.TWAMP]: [
    {
      testMode: TestMode.DEFAULT,
      agentTypes: [
        AGENT_MODEL.QT600,
        AGENT_MODEL.VPMA,
        AGENT_MODEL.VPMA_L,
        AGENT_MODEL.JMEP_1G,
        'vspa-pm',
        'vspa-pm-l'
      ],
      showDestination: false,
      agentCapabilityCheck: {
        section: 'twamp-initiator',
        section1: 'twamp-initiator-list'
      }
    }
  ],
  [TestTypeValue.TWAMP_REFLECTOR]: [
    {
      testMode: TestMode.DEFAULT,
      agentTypes: [
        AGENT_MODEL.QT600,
        AGENT_MODEL.VPMA,
        AGENT_MODEL.VPMA_L,
        AGENT_MODEL.JMEP_10G,
        AGENT_MODEL.JMEP_1G,
        AGENT_MODEL.VQT,
        'vspa-pm',
        'vspa-pm-l'
      ],
      showDestination: false
    }
  ],
  [TestTypeValue.Y1731]: [
    {
      agentTypes: [AGENT_MODEL.VPMA, AGENT_MODEL.VPMA_L, 'vspa-pm', 'vspa-pm-l'],
      showDestination: false
    }
  ],
  [TestTypeValue.UDP]: [
    {
      testMode: TestMode.CLIENT_TO_MA,
      directions: [
        { name: TestModeLabel.UNIDIRECIONAL_A_TO_B, value: TestMode.UNIDIRECIONAL_A_TO_B },
        { name: TestModeLabel.UNIDIRECIONAL_B_TO_A, value: TestMode.UNIDIRECIONAL_B_TO_A },
        { name: TestModeLabel.SEQUENTIAL, value: TestMode.SEQUENTIAL }
      ],
      agentTypes: ['vta-ts', 'vspa-sat-ts'],
      agentCapabilityCheck: {
        section: 'udp',
        field: 'public-access',
        value: 'true',
        section1: 'udp-list'
      },
      showDestination: false,
      testModeName: TestModeLabel.CLIENT_TO_MA
    },
    {
      testMode: TestMode.MA_TO_MA,
      directions: [
        { name: TestModeLabel.UNIDIRECIONAL_A_TO_B, value: TestMode.UNIDIRECIONAL_A_TO_B },
        { name: TestModeLabel.UNIDIRECIONAL_B_TO_A, value: TestMode.UNIDIRECIONAL_B_TO_A },
        { name: TestModeLabel.CONCURRENT, value: TestMode.CONCURRENT },
        { name: TestModeLabel.SEQUENTIAL, value: TestMode.SEQUENTIAL }
      ],
      agentTypes: ['vta', 'vspa-sat'],
      showDestination: true,
      testModeName: TestModeLabel.MA_TO_MA
    }
  ],
  [TestTypeValue.HTTP]: [
    {
      testMode: TestMode.MA_TO_SERVER,
      directions: [
        { name: TestModeLabel.UPLOAD, value: TestMode.UPLOAD },
        { name: TestModeLabel.DOWNLOAD, value: TestMode.DOWNLOAD },
        { name: TestModeLabel.UPLOAD_AND_DOWNLOAD, value: TestMode.UPLOAD_AND_DOWNLOAD }
      ],
      agentTypes: ['vta', 'vspa-sat'],
      showDestination: true,
      testModeName: TestModeLabel.MA_TO_SERVER,
      agentCapabilityCheck: {
        section: 'http'
      }
    },
    {
      testMode: TestMode.MA_TO_EXTERNAL,
      directions: [
        { name: TestModeLabel.UPLOAD, value: TestMode.UPLOAD },
        { name: TestModeLabel.DOWNLOAD, value: TestMode.DOWNLOAD },
        { name: TestModeLabel.UPLOAD_AND_DOWNLOAD, value: TestMode.UPLOAD_AND_DOWNLOAD }
      ],
      agentTypes: ['vta', 'vspa-sat'],
      showDestination: false,
      testModeName: TestModeLabel.MA_TO_EXTERNAL,
      agentCapabilityCheck: {
        section: 'http'
      }
    }
  ],
  [TestTypeValue.FTP]: [
    {
      testMode: TestMode.MA_TO_SERVER,
      directions: [
        { name: TestModeLabel.UPLOAD, value: TestMode.UPLOAD },
        { name: TestModeLabel.DOWNLOAD, value: TestMode.DOWNLOAD },
        { name: TestModeLabel.UPLOAD_AND_DOWNLOAD, value: TestMode.UPLOAD_AND_DOWNLOAD }
      ],
      agentTypes: ['vta', 'vspa-sat'],
      showDestination: true,
      testModeName: TestModeLabel.MA_TO_SERVER,
      agentCapabilityCheck: {
        section: 'ftp'
      }
    }
  ],
  [TestTypeValue.BERT]: [
    {
      testMode: TestMode.LOOPBACK,
      agentTypes: ['jmep-10g'],
      showDestination: true,
      destAgentTypes: [
        'unmanaged',
        'vta-lb',
        'vspa-sat-lb',
        AGENT_MODEL.JMEP_10G,
        AGENT_MODEL.JMEP_1G
      ],
      testModeName: TestModeLabel.LOOPBACK
    }
  ]
};

export interface IEngineInfo {
  'engine-type': string;
  'agent-type'?: string;
  address: string;
  port: string;
  'test-ip': string;
  'test-subnet-mask': string;
  'test-gateway': string;
}
